module.exports = "/_next/static/media/9b4828f50cb1174ff391eb200a27cce0.svg";